<header>
  <app-header class="flex justify-between items-center border-b-1 border-surface-300 dark:border-surface-700" [authenticated]="authenticated()"></app-header>
</header>
<div class="flex" style="height: calc(100% - 6.625rem);">
  @if (authenticated()) {
    <app-left-sidebar class="overflow-y-auto shrink-0 border-r border-surface-300 dark:border-surface-700"></app-left-sidebar>
  }
  <main class="w-full relative">
    <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
    @if (!isIframe) {
      <p-blockui [blocked]="loading() && !authenticated() && !isLogoutPage" />
      <p-blockui [target]="content" [blocked]="authenticated() && loading()" />
      <p-panel #content class="content" [ngClass]="{'hidden': showHelp()}" styleClass="bg-surface-100 dark:bg-surface-900 h-full border-0 rounded-none main-content-panel">
        <ng-template #header>
          <h1 class="page-title text-lg text-surface-500">{{pageTitle()}}</h1>
        </ng-template>
        <div class="h-full overflow-y-auto flex flex-col px-4">
          <router-outlet></router-outlet>
          <p-toast position="center" key="center"/>
        </div>
      </p-panel>
      @if (loading()) {
        <div style="z-index:1200" class="absolute left-0 right-0 top-0 bottom-0 flex justify-center items-center">
          <p-progress-spinner ariaLabel="loading" />
        </div>
      }
    }
  <p-toast position="top-right" key="main"/>
  @if (showHelp()) {
    <app-help-overlay class="absolute left-0 top-0 right-0 bottom-0"></app-help-overlay>
  }
  </main>
  
</div>
<footer class="flex-initial border-t-1 border-surface-300 dark:border-surface-700 dark:bg-surface-950">
  <app-footer class="m-2 text-center block"></app-footer>
</footer>
